import { combineQueries, createEntityQuery } from '@datorama/akita';
import { isEqual } from 'lodash-es';
import { distinctUntilChanged, map } from 'rxjs';
import store from './store';
import { activeOrganisationId$, subsidiaryIds$ } from 'context/OrganisationContext/query';
import { includeSubsidiaries$ } from 'context/UserContext/query';
import { activeEntity$ as activeReportingStandard$ } from 'state/ReportingStandards/query';
import { type KpiScope } from 'types/models';

export const query = createEntityQuery(store);

export const activeEntity$ = query.selectActive();
export const entities$ = query.selectAll();
export const loading$ = query.selectLoading();
export const pendingUploads$ = query.select('pendingUploads');
export const pendingDeletions$ = query.select('pendingDeletions');
export const entitiesESRSDMA$ = combineQueries([
   entities$,
   includeSubsidiaries$,
   activeOrganisationId$,
   subsidiaryIds$,
   activeReportingStandard$,
]).pipe(
   map(([entities, includeSubsidiaries, activeOrganisationId, subsidiaryIds, activeReportingStandard]) =>
      Array.isArray(entities)
         ? entities.filter(
              ({ kpiTopics = [], materialityType, organisationId, reportingStandard }) =>
                 (activeReportingStandard?.key === 'ESRS' ? kpiTopics.length > 0 : true) &&
                 reportingStandard?.key === activeReportingStandard?.key &&
                 !!materialityType &&
                 (includeSubsidiaries ? [activeOrganisationId, ...subsidiaryIds].includes(organisationId) : organisationId === activeOrganisationId)
           )
         : []
   ),
   distinctUntilChanged<KpiScope[]>(isEqual)
);
